import React from "react";
import { Div } from "../../atoms/Div";

/**
 * Minimal header shown while Keycloak authentication is in progress.
 * ASSUMPTION: Hamburger is decorative only during auth bootstrap (no menu).
 */
export const NavbarAuthLoading = () => (
  <Div className="navbarAuthLoading">
    <Div className="navbarAuthLoading__left-side">
      <Div
        className="navbarAuthLoading__burgerIcon"
        aria-hidden="true"
        role="presentation"
      />
      <Div className="navbarAuthLoading__smartman-logo" aria-label="Smartman" />
    </Div>
  </Div>
);
